module.exports = __webpack_public_path__ + "img/sg-bg.f42008b8.jpg";